module.exports = __webpack_public_path__ + "img/logout.889a3439.svg";